"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.countDecimals = countDecimals;
exports.roundToIncrement = roundToIncrement;
exports.truncate = truncate;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Tooltip = _interopRequireDefault(require("./Tooltip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Determines the number of digits after the decimal place. Returns 0 if there are none.
 * @param {number} num any real number
 * @returns {number} - an integer denoting the number of decimal digits
 */
function countDecimals(num) {
  if (Math.floor(num) === num) return 0;
  return num.toString().split('.')[1].length;
}
/**
 * Rounds the given number to the closest increment. The increment can be any real number.
 * @param {number} num any real number
 * @param {number} inc any real number
 * @returns {number} - num rounded to the closest increment.
 */


function roundToIncrement(num, inc) {
  return Math.round(Math.round(num / (inc / 10)) / 10) * inc; // https://gordonlesti.com/inaccurate-rounding-with-decimal-digits/
}
/**
 * Set the number a string, truncate to the given decimal point, and cut off any extraneous decimal zeroes.
 * @param {number} num any real number
 * @param {number} decimals any integer
 * @returns {number} - num truncated to the decimals, plus any extra zeroes removed.
 */


function truncate(num, decimals) {
  // toFixed() solves the problem of floats (such as 1.0000000000000000012) being returned from increment.
  // the replace() will then determine if the result is a decimal with trailing zeroes, and remove the zeroes/decimal if applicable.
  return num.toFixed(decimals).replace(/\.\d*0+$/, function (match) {
    return match.replace(/\.?0+$/, '');
  });
}

var barWidth = 0;
var barLeft = 0;
var touchIdentifier = 0;

function getPosition(element) {
  var box = element.getBoundingClientRect();
  return {
    left: box.left + window.scrollX,
    top: box.top + window.scrollY,
    width: box.width,
    height: box.height
  };
}

function getMouseX(e) {
  // Regular mouse events.
  if (typeof e.pageX === 'number' && e.pageX === e.pageX) {
    // eslint-disable-line no-self-compare
    return e.pageX;
  } // Touch events.


  for (var i = 0; i < e.changedTouches.length; i += 1) {
    if (e.changedTouches[i].identifier === touchIdentifier) {
      return e.changedTouches[i].pageX;
    }
  }

  return 0; // It should never get here.
}

var Slider =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Slider, _PureComponent);

  function Slider() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Slider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Slider)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      internalNumber: _this.props.value,
      displayString: _this.props.value.toString(),
      roundedNumber: _this.props.value,
      decimals: countDecimals(_this.props.increment)
    });

    _defineProperty(_assertThisInitialized(_this), "onDragMove", function (e) {
      var _this$props = _this.props,
          max = _this$props.max,
          min = _this$props.min,
          selectOnDrag = _this$props.selectOnDrag,
          onSelect = _this$props.onSelect,
          value = _this$props.value,
          increment = _this$props.increment;
      var decimals = _this.state.decimals;
      var mouseX = getMouseX(e);
      var internalNumber;

      if (mouseX <= barLeft) {
        internalNumber = min;
      } else if (mouseX >= barLeft + barWidth) {
        internalNumber = max;
      } else {
        var range = max - min;
        var percentage = (mouseX - barLeft) / barWidth;
        internalNumber = min + percentage * range;
      }

      var roundedNumber = roundToIncrement(internalNumber, increment);
      var displayString = truncate(roundedNumber, decimals);

      _this.setState({
        internalNumber: internalNumber,
        roundedNumber: roundedNumber,
        displayString: displayString
      });

      if (selectOnDrag && roundedNumber !== value) {
        onSelect(roundedNumber);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDragEnd", function () {
      document.removeEventListener('mousemove', _this.onDragMove);
      document.removeEventListener('touchmove', _this.onDragMove);
      document.removeEventListener('mouseup', _this.onDragEnd);
      document.removeEventListener('touchend', _this.onDragEnd);

      _this.setState({
        dragging: false
      });

      _this.props.onSelect(_this.state.roundedNumber);
    });

    _defineProperty(_assertThisInitialized(_this), "onDragStart", function (e) {
      if (!_this.props.disabled) {
        var barPosition = getPosition(_this.bar);
        barLeft = barPosition.left;
        barWidth = barPosition.width;

        if (e.targetTouches) {
          touchIdentifier = e.targetTouches[0].identifier;
        }

        _this.setState({
          dragging: true
        });

        document.addEventListener('mousemove', _this.onDragMove);
        document.addEventListener('touchmove', _this.onDragMove);
        document.addEventListener('mouseup', _this.onDragEnd);
        document.addEventListener('touchend', _this.onDragEnd);

        _this.onDragMove(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseOver", function () {
      _this.setState({
        hover: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseOut", function () {
      _this.setState({
        hover: false
      });
    });

    return _this;
  }

  _createClass(Slider, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      // eslint-disable-line camelcase
      if (nextProps.value !== this.state.roundedNumber) {
        this.setState({
          internalNumber: nextProps.value,
          displayString: nextProps.value.toString(),
          roundedNumber: nextProps.value
        });
      }

      if (nextProps.increment !== this.props.increment) {
        this.setState({
          decimals: countDecimals(nextProps.increment)
        });
      }
    }
    /* eslint-disable no-return-assign */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          internalNumber = _this$state.internalNumber,
          hover = _this$state.hover,
          dragging = _this$state.dragging,
          displayString = _this$state.displayString;
      var _this$props2 = this.props,
          label = _this$props2.label,
          min = _this$props2.min,
          max = _this$props2.max,
          disabled = _this$props2.disabled;
      var left = "".concat(100 * ((internalNumber - min) / (max - min)), "%");
      var focusClass = hover || dragging ? ' slider-focus' : '';
      return _react["default"].createElement("div", {
        className: "slider".concat(focusClass),
        disabled: disabled,
        onMouseOver: this.onMouseOver,
        onFocus: this.onMouseOver,
        onMouseOut: this.onMouseOut,
        onBlur: this.onMouseOut
      }, _react["default"].createElement("div", {
        className: "slider-title"
      }, label), _react["default"].createElement("div", {
        ref: function ref(_ref) {
          return _this2.bar = _ref;
        },
        className: "slider-bar",
        onTouchStart: this.onDragStart,
        onMouseDown: this.onDragStart
      }, _react["default"].createElement("div", {
        className: "slider-progress-bar",
        style: {
          width: left
        }
      })), _react["default"].createElement("div", {
        className: "slider-handle",
        style: {
          left: left
        }
      }, _react["default"].createElement(_Tooltip["default"], {
        direction: "bottom",
        show: Boolean(focusClass),
        variety: "popover",
        contents: displayString
      }, _react["default"].createElement("div", {
        className: "slider-virtual-handle",
        onMouseDown: this.onDragStart,
        onTouchStart: this.onDragStart
      }))), _react["default"].createElement("div", {
        className: "slider-values"
      }, _react["default"].createElement("div", {
        className: "slider-min"
      }, min), _react["default"].createElement("div", {
        className: "slider-max"
      }, max)));
    }
  }]);

  return Slider;
}(_react.PureComponent);

exports["default"] = Slider;
Slider.propTypes = {
  label: _propTypes["default"].string.isRequired,
  disabled: _propTypes["default"].bool,
  min: _propTypes["default"].number,
  max: _propTypes["default"].number,
  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]).isRequired,
  onSelect: _propTypes["default"].func.isRequired,
  increment: _propTypes["default"].number,
  selectOnDrag: _propTypes["default"].bool
};
Slider.defaultProps = {
  disabled: false,
  increment: 1,
  min: 0,
  max: 100,
  selectOnDrag: false
};